// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h1, h3, h2 span {
  font-family: 'Segoe', sans-serif; /* Example font-family */
  letter-spacing: -0.1rem;
  line-height: 2.25rem;
  font-weight: 600;
  font-size: 2.3rem;
  display: inline;

  }
  @keyframes devAnimation {
    0% {
      opacity: 0;
      transform: translateX(-20%);
    }
    50% {
      opacity: 1;
      transform: translateX(0%);
    }
    100% {
      opacity: 0;
      transform: translateX(100%);
    }
  }
  
  .dev-text {
    font-family: 'Courier', sans-serif; /* Example font-family */
    animation: devAnimation 5s infinite; /* Adjust the duration and other properties as needed */
  }


.pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  animation-delay: 0.5s;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.95;
    transform: scale(1.01);
  }
}

.avatar-holder{
  align-items: center;
}

@keyframes rotate-color {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.animate-gradient {
  animation: rotate-color 5s linear infinite;
  -webkit-animation: rotate-color 5s linear infinite;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInLeft {
  from {
    opacity: 0;
    transform: translateX(-20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes fadeInRight {
  0% {
    opacity: 0;
    transform: translateX(20px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes scaleIn {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes float {
  0% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-10px);
  }
  100% {
    transform: translateY(0px);
  }
}

@keyframes spin-slow {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes gradientFlow {
  0% {
    background-position: 0% 0%;
  }
  50% {
    background-position: 100% 100%;
  }
  100% {
    background-position: 0% 0%;
  }
}

@keyframes arrowBounce {
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-15px);
  }
  60% {
    transform: translateY(-7px);
  }
}

.animate-fadeInUp {
  animation: fadeInUp 0.7s ease-out forwards;
}

.animate-fadeInDown {
  animation: fadeInDown 0.7s ease-out forwards;
}

.animate-fadeInLeft {
  animation: fadeInLeft 0.7s ease-out forwards;
}

.animate-fadeInRight {
  animation: fadeInRight 0.8s ease-out forwards;
}

.animate-scaleIn {
  animation: scaleIn 0.5s ease-out forwards;
}

.animate-float {
  animation: float 4s ease-in-out infinite;
}

.animate-spin-slow {
  animation: spin-slow 12s linear infinite;
}

.animate-arrowBounce {
  animation: arrowBounce 2s infinite;
}

.animate-gradientFlow {
  background-size: 200% 200%;
  animation: gradientFlow 10s ease infinite;
}

/* Animation delay utilities */
.delay-100 {
  animation-delay: 100ms;
}

.delay-200 {
  animation-delay: 200ms;
}

.delay-300 {
  animation-delay: 300ms;
}

.delay-400 {
  animation-delay: 400ms;
}

.delay-500 {
  animation-delay: 500ms;
}

.delay-600 {
  animation-delay: 600ms;
}

.delay-700 {
  animation-delay: 700ms;
}

.delay-800 {
  animation-delay: 800ms;
}

.delay-900 {
  animation-delay: 900ms;
}

.delay-1000 {
  animation-delay: 1000ms;
}

/* Add perspective for 3D effects */
.perspective {
  perspective: 1000px;
}

.backface-hidden {
  backface-visibility: hidden;
}

/* For scroll-triggered animations */
.reveal {
  position: relative;
  transform: translateY(50px);
  opacity: 0;
  transition: all 1s ease;
  z-index: 1;
  overflow: visible;
}

.reveal.active {
  transform: translateY(0px);
  opacity: 1;
  z-index: 1;
  overflow: visible;
}

/* Add additional spacing for section containers */
#content-section section {
  position: relative;

  z-index: 1;
  overflow: visible;
}

/* Ensure animations don't cause layout issues */
.animate-fadeInUp {
  animation-fill-mode: forwards;
  position: relative;
  z-index: 1;
}

/* Enhance animation for education cards */
.rounded-lg.animate-fadeInRight {
  animation: fadeInRight 0.8s ease-out forwards;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.rounded-lg.animate-fadeInRight:hover {
  transform: translateY(-4px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
}

/* Special animation for education cards */
#education .relative.group {
  transform-origin: center;
  transition: all 0.4s ease;
}

#education .relative.group:hover {
  z-index: 20;
}

#education .line-clamp-4 {
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;  
  overflow: hidden;
}

#education .group:hover .line-clamp-4 {
  -webkit-line-clamp: unset;
}

/* Improved pulse animation */
@keyframes gentle-pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(0, 113, 194, 0.2);
  }
  70% {
    box-shadow: 0 0 0 8px rgba(0, 113, 194, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(0, 113, 194, 0);
  }
}

#education .flex-shrink-0 {
  animation: gentle-pulse 2s infinite;
}

/* Improve spacing for education section */
#education {
  position: relative;
  overflow: visible;
  z-index: 2;
}

#education h2 {
  position: relative;
  display: inline-block;
}

/* Remove the underline */
#education h2:after {
  display: none;
}

/* Collapsible sections styling */
.section-header {
  transition: all 0.3s ease;
  cursor: pointer;

}

.section-header:hover {
  transform: translateY(-2px);
}

/* Make section headers more visually clickable */
#skills .section-header, 
#education .section-header,
#experience .section-header,
#contact .section-header {
  position: relative;
}

/* Add visual indication for collapsible state */
#skills .section-header h2::after,
#education .section-header h2::after,
#experience .section-header h2::after,
#contact .section-header h2::after {
  content: '';
  display: block;
  width: 100%;
  height: 2px;
  background: #0071c2;
  opacity: 0;
  transition: opacity 0.3s ease;
  margin-top: 4px;
}

#skills .section-header:hover h2::after,
#education .section-header:hover h2::after,
#experience .section-header:hover h2::after,
#contact .section-header:hover h2::after {
  opacity: 0.7;
}

.collapsible-content {
  transition: max-height 0.5s ease, opacity 0.3s ease;
}

.collapsible-content.collapsed {
  max-height: 0;
  opacity: 0;
  overflow: hidden;
  margin: 0;
  padding: 0;
}

.collapsible-content.expanded {
  max-height: 2000px;
  opacity: 1;
}

/* Arrow animation */
.arrow-icon {
  transition: transform 0.3s ease;
}

.arrow-icon.rotated {
  transform: rotate(180deg);
}

/* Ensure skills cards display properly */
#skills {
  position: relative;
  overflow: visible;
  z-index: 2;
}

#skills .grid {
  overflow: visible;
}

#skills .grid > div {
  height: 100%;
  display: flex;
  flex-direction: column;
}

#skills .grid > div > div {
  flex: 1 1;
  display: flex;
  flex-direction: column;
}

#skills p.break-words {
  word-break: break-word;
  overflow-wrap: break-word;
}

/* Ensure experience cards display properly */
#experience {
  position: relative;
  overflow: visible;
  z-index: 2;
}

#experience .grid {
  overflow: visible;
}

#experience .grid > article {
  height: 100%;
  overflow: visible;

}

#skills p.break-words {
  word-break: break-word;
  overflow-wrap: break-word;
}`, "",{"version":3,"sources":["webpack://./src/views/index/style.css"],"names":[],"mappings":"AAAA;EACE,gCAAgC,EAAE,wBAAwB;EAC1D,uBAAuB;EACvB,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;;EAEf;EACA;IACE;MACE,UAAU;MACV,2BAA2B;IAC7B;IACA;MACE,UAAU;MACV,yBAAyB;IAC3B;IACA;MACE,UAAU;MACV,2BAA2B;IAC7B;EACF;;EAEA;IACE,kCAAkC,EAAE,wBAAwB;IAC5D,mCAAmC,EAAE,uDAAuD;EAC9F;;;AAGF;EACE,yDAAyD;EACzD,qBAAqB;AACvB;;AAEA;EACE;IACE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,sBAAsB;EACxB;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;AASA;EACE,0CAA0C;EAC1C,kDAAkD;AACpD;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,sBAAsB;EACxB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,0BAA0B;EAC1B,yCAAyC;AAC3C;;AAEA,8BAA8B;AAC9B;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA,mCAAmC;AACnC;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,oCAAoC;AACpC;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,UAAU;EACV,uBAAuB;EACvB,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,UAAU;EACV,UAAU;EACV,iBAAiB;AACnB;;AAEA,kDAAkD;AAClD;EACE,kBAAkB;;EAElB,UAAU;EACV,iBAAiB;AACnB;;AAEA,gDAAgD;AAChD;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,UAAU;AACZ;;AAEA,0CAA0C;AAC1C;EACE,6CAA6C;EAC7C,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA,0CAA0C;AAC1C;EACE,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,6BAA6B;AAC7B;EACE;IACE,0CAA0C;EAC5C;EACA;IACE,0CAA0C;EAC5C;EACA;IACE,wCAAwC;EAC1C;AACF;;AAEA;EACE,mCAAmC;AACrC;;AAEA,0CAA0C;AAC1C;EACE,kBAAkB;EAClB,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA,yBAAyB;AACzB;EACE,aAAa;AACf;;AAEA,iCAAiC;AACjC;EACE,yBAAyB;EACzB,eAAe;;AAEjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,iDAAiD;AACjD;;;;EAIE,kBAAkB;AACpB;;AAEA,gDAAgD;AAChD;;;;EAIE,WAAW;EACX,cAAc;EACd,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,UAAU;EACV,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;;;;EAIE,YAAY;AACd;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,aAAa;EACb,UAAU;EACV,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA,oBAAoB;AACpB;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,yCAAyC;AACzC;EACE,kBAAkB;EAClB,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA,6CAA6C;AAC7C;EACE,kBAAkB;EAClB,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,iBAAiB;;AAEnB;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;AAC3B","sourcesContent":["h1, h3, h2 span {\n  font-family: 'Segoe', sans-serif; /* Example font-family */\n  letter-spacing: -0.1rem;\n  line-height: 2.25rem;\n  font-weight: 600;\n  font-size: 2.3rem;\n  display: inline;\n\n  }\n  @keyframes devAnimation {\n    0% {\n      opacity: 0;\n      transform: translateX(-20%);\n    }\n    50% {\n      opacity: 1;\n      transform: translateX(0%);\n    }\n    100% {\n      opacity: 0;\n      transform: translateX(100%);\n    }\n  }\n  \n  .dev-text {\n    font-family: 'Courier', sans-serif; /* Example font-family */\n    animation: devAnimation 5s infinite; /* Adjust the duration and other properties as needed */\n  }\n\n\n.pulse {\n  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;\n  animation-delay: 0.5s;\n}\n\n@keyframes pulse {\n  0%, 100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n  50% {\n    opacity: 0.95;\n    transform: scale(1.01);\n  }\n}\n\n.avatar-holder{\n  align-items: center;\n}\n\n@keyframes rotate-color {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n@-webkit-keyframes rotate-color {\n  from {\n    -webkit-transform: rotate(0deg);\n  }\n  to {\n    -webkit-transform: rotate(360deg);\n  }\n}\n.animate-gradient {\n  animation: rotate-color 5s linear infinite;\n  -webkit-animation: rotate-color 5s linear infinite;\n}\n\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes fadeInDown {\n  from {\n    opacity: 0;\n    transform: translateY(-20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes fadeInLeft {\n  from {\n    opacity: 0;\n    transform: translateX(-20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n@keyframes fadeInRight {\n  0% {\n    opacity: 0;\n    transform: translateX(20px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n@keyframes scaleIn {\n  from {\n    opacity: 0;\n    transform: scale(0.95);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n@keyframes float {\n  0% {\n    transform: translateY(0px);\n  }\n  50% {\n    transform: translateY(-10px);\n  }\n  100% {\n    transform: translateY(0px);\n  }\n}\n\n@keyframes spin-slow {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes gradientFlow {\n  0% {\n    background-position: 0% 0%;\n  }\n  50% {\n    background-position: 100% 100%;\n  }\n  100% {\n    background-position: 0% 0%;\n  }\n}\n\n@keyframes arrowBounce {\n  0%, 20%, 50%, 80%, 100% {\n    transform: translateY(0);\n  }\n  40% {\n    transform: translateY(-15px);\n  }\n  60% {\n    transform: translateY(-7px);\n  }\n}\n\n.animate-fadeInUp {\n  animation: fadeInUp 0.7s ease-out forwards;\n}\n\n.animate-fadeInDown {\n  animation: fadeInDown 0.7s ease-out forwards;\n}\n\n.animate-fadeInLeft {\n  animation: fadeInLeft 0.7s ease-out forwards;\n}\n\n.animate-fadeInRight {\n  animation: fadeInRight 0.8s ease-out forwards;\n}\n\n.animate-scaleIn {\n  animation: scaleIn 0.5s ease-out forwards;\n}\n\n.animate-float {\n  animation: float 4s ease-in-out infinite;\n}\n\n.animate-spin-slow {\n  animation: spin-slow 12s linear infinite;\n}\n\n.animate-arrowBounce {\n  animation: arrowBounce 2s infinite;\n}\n\n.animate-gradientFlow {\n  background-size: 200% 200%;\n  animation: gradientFlow 10s ease infinite;\n}\n\n/* Animation delay utilities */\n.delay-100 {\n  animation-delay: 100ms;\n}\n\n.delay-200 {\n  animation-delay: 200ms;\n}\n\n.delay-300 {\n  animation-delay: 300ms;\n}\n\n.delay-400 {\n  animation-delay: 400ms;\n}\n\n.delay-500 {\n  animation-delay: 500ms;\n}\n\n.delay-600 {\n  animation-delay: 600ms;\n}\n\n.delay-700 {\n  animation-delay: 700ms;\n}\n\n.delay-800 {\n  animation-delay: 800ms;\n}\n\n.delay-900 {\n  animation-delay: 900ms;\n}\n\n.delay-1000 {\n  animation-delay: 1000ms;\n}\n\n/* Add perspective for 3D effects */\n.perspective {\n  perspective: 1000px;\n}\n\n.backface-hidden {\n  backface-visibility: hidden;\n}\n\n/* For scroll-triggered animations */\n.reveal {\n  position: relative;\n  transform: translateY(50px);\n  opacity: 0;\n  transition: all 1s ease;\n  z-index: 1;\n  overflow: visible;\n}\n\n.reveal.active {\n  transform: translateY(0px);\n  opacity: 1;\n  z-index: 1;\n  overflow: visible;\n}\n\n/* Add additional spacing for section containers */\n#content-section section {\n  position: relative;\n\n  z-index: 1;\n  overflow: visible;\n}\n\n/* Ensure animations don't cause layout issues */\n.animate-fadeInUp {\n  animation-fill-mode: forwards;\n  position: relative;\n  z-index: 1;\n}\n\n/* Enhance animation for education cards */\n.rounded-lg.animate-fadeInRight {\n  animation: fadeInRight 0.8s ease-out forwards;\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.rounded-lg.animate-fadeInRight:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);\n}\n\n/* Special animation for education cards */\n#education .relative.group {\n  transform-origin: center;\n  transition: all 0.4s ease;\n}\n\n#education .relative.group:hover {\n  z-index: 20;\n}\n\n#education .line-clamp-4 {\n  display: -webkit-box;\n  -webkit-line-clamp: 4;\n  -webkit-box-orient: vertical;  \n  overflow: hidden;\n}\n\n#education .group:hover .line-clamp-4 {\n  -webkit-line-clamp: unset;\n}\n\n/* Improved pulse animation */\n@keyframes gentle-pulse {\n  0% {\n    box-shadow: 0 0 0 0 rgba(0, 113, 194, 0.2);\n  }\n  70% {\n    box-shadow: 0 0 0 8px rgba(0, 113, 194, 0);\n  }\n  100% {\n    box-shadow: 0 0 0 0 rgba(0, 113, 194, 0);\n  }\n}\n\n#education .flex-shrink-0 {\n  animation: gentle-pulse 2s infinite;\n}\n\n/* Improve spacing for education section */\n#education {\n  position: relative;\n  overflow: visible;\n  z-index: 2;\n}\n\n#education h2 {\n  position: relative;\n  display: inline-block;\n}\n\n/* Remove the underline */\n#education h2:after {\n  display: none;\n}\n\n/* Collapsible sections styling */\n.section-header {\n  transition: all 0.3s ease;\n  cursor: pointer;\n\n}\n\n.section-header:hover {\n  transform: translateY(-2px);\n}\n\n/* Make section headers more visually clickable */\n#skills .section-header, \n#education .section-header,\n#experience .section-header,\n#contact .section-header {\n  position: relative;\n}\n\n/* Add visual indication for collapsible state */\n#skills .section-header h2::after,\n#education .section-header h2::after,\n#experience .section-header h2::after,\n#contact .section-header h2::after {\n  content: '';\n  display: block;\n  width: 100%;\n  height: 2px;\n  background: #0071c2;\n  opacity: 0;\n  transition: opacity 0.3s ease;\n  margin-top: 4px;\n}\n\n#skills .section-header:hover h2::after,\n#education .section-header:hover h2::after,\n#experience .section-header:hover h2::after,\n#contact .section-header:hover h2::after {\n  opacity: 0.7;\n}\n\n.collapsible-content {\n  transition: max-height 0.5s ease, opacity 0.3s ease;\n}\n\n.collapsible-content.collapsed {\n  max-height: 0;\n  opacity: 0;\n  overflow: hidden;\n  margin: 0;\n  padding: 0;\n}\n\n.collapsible-content.expanded {\n  max-height: 2000px;\n  opacity: 1;\n}\n\n/* Arrow animation */\n.arrow-icon {\n  transition: transform 0.3s ease;\n}\n\n.arrow-icon.rotated {\n  transform: rotate(180deg);\n}\n\n/* Ensure skills cards display properly */\n#skills {\n  position: relative;\n  overflow: visible;\n  z-index: 2;\n}\n\n#skills .grid {\n  overflow: visible;\n}\n\n#skills .grid > div {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n#skills .grid > div > div {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n}\n\n#skills p.break-words {\n  word-break: break-word;\n  overflow-wrap: break-word;\n}\n\n/* Ensure experience cards display properly */\n#experience {\n  position: relative;\n  overflow: visible;\n  z-index: 2;\n}\n\n#experience .grid {\n  overflow: visible;\n}\n\n#experience .grid > article {\n  height: 100%;\n  overflow: visible;\n\n}\n\n#skills p.break-words {\n  word-break: break-word;\n  overflow-wrap: break-word;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
